import { useState, createContext, useEffect } from 'react'

export const context = createContext()

const PhaserProvider = ({ game, scene, sceneProps, children }) => {
  const [ready, setReady] = useState()
  
  // delay to let the context value to propagate before rendering children.
  // this way children can implement usePhaser confident that objects returned are not null
  useEffect(() => {
    setReady(!!game && !!scene)
  }, [game, scene])

  return (
    <context.Provider value={{ game, scene, sceneProps }}>
      {
        ready ? children : null
      }
    </context.Provider>
  )
}

export default PhaserProvider
